import RedactionTextPreviewContainer from './RedactionTextPreviewContainer';

export default RedactionTextPreviewContainer;